import React, { useEffect, useState } from 'react'
import { Axios } from './Axios'
import { Navigate } from 'react-router-dom'

function ProtectedRoute({ children }) {

    const [isAuthenticated, setIsAuthenticated] = useState(null)

    useEffect(() => {
        const isLogin = () => {
            Axios.get('/auth/verify').then(res => {
                setIsAuthenticated(res)
            }).catch(err => {
                setIsAuthenticated(false)
            })
        }
        isLogin()
    }, [])


    if (isAuthenticated == null) {
        return (
            <div>Loading...</div>
        )
    }

    return isAuthenticated ? children : <Navigate to='/login' />
}

export default ProtectedRoute